import { render, staticRenderFns } from "./BootheventEdit.vue?vue&type=template&id=85703d68&"
import script from "./BootheventEdit.vue?vue&type=script&lang=js&"
export * from "./BootheventEdit.vue?vue&type=script&lang=js&"
import style0 from "./BootheventEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports